import { useEffect, useRef, useState } from "react";

export const useCountdown = (targetDate: Date, autoReset = false) => {
  const calculateTimeLeft = (target: Date) => {
    const now = new Date();
    return Math.max(0, target.getTime() - now.getTime());
  };

  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(targetDate));
  const targetDateRef = useRef(targetDate);

  // Update timeLeft immediately when targetDate changes
  useEffect(() => {
    if (targetDateRef.current.getTime() !== targetDate.getTime()) {
      targetDateRef.current = targetDate;
      setTimeLeft(calculateTimeLeft(targetDate));
    }
  }, [targetDate]);

  useEffect(() => {
    // Пересчитываем время при возвращении на страницу
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setTimeLeft(calculateTimeLeft(targetDateRef.current));
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    const interval = setInterval(() => {
      const newTimeLeft = calculateTimeLeft(targetDateRef.current);
      setTimeLeft(newTimeLeft);

      if (newTimeLeft <= 0 && autoReset) {
        setTimeLeft(calculateTimeLeft(targetDateRef.current));
      }
    }, 1000);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [autoReset]);

  return timeLeft;
};
